const jivoScript = document.createElement('script');
jivoScript.setAttribute('src', '//code.jivo.ru/widget/GuYMrm8sO5');
jivoScript.async = true;

document.head.appendChild(jivoScript); 
